import { TASK_DUPLICATED, insertTaskDuplicate } from './taskMotionReducer';
const defaultState = {
    todos: [],
}

const ADD_TODO = "ADD_TODO"
const REMOVE_TODO = "REMOVE_TODO"
const LOAD_DATA_TODO = "LOAD_DATA_TODO"
const SET_BACKLOG = "SET_BACKLOG"

export const todosReducer = (state = defaultState, action) => {
    switch(action.type) {
      case TASK_DUPLICATED:
        return {...state, todos: insertTaskDuplicate(state.todos, action.payload.sourceId, action.payload.task)};
      case ADD_TODO:
        return {...state, todos: [...state.todos, action.payload]} 
      case REMOVE_TODO:
        return {...state, todos: state.todos.filter(todos => todos.id !== action.payload)}
      case LOAD_DATA_TODO:
        return {...state, todos: action.payload.map((newTodo) => {
            const existing = state.todos.find((t) => t.id === newTodo.id);
            return {...newTodo, isBacklog: existing ? existing.isBacklog : false};
        })}
      case SET_BACKLOG:
        return {...state, todos: state.todos.map(t => 
            t.id === action.payload.id ? {...t, isBacklog: action.payload.isBacklog} : t
        )}
      default:
        return state
    }
  }

export const addTodoAction = (payload) => ({type: ADD_TODO, payload})
export const removeTodoToday = (payload) => ({type: REMOVE_TODO, payload})
export const loadDataTodo = (payload) => ({type: LOAD_DATA_TODO, payload})
export const setTodoBacklog = (payload) => ({type: SET_BACKLOG, payload})
